(function() {
  document.addEventListener('DOMContentLoaded', () => {
    const $body = document.body;

    const setupScrollLock = function() {
      let _windowPosition = window.scrollY;

      const restoreScroll = function() {
        $body.style.top = '';
        $body.classList.remove('locked');

        // reset the window y position to where it was
        // when the menu was opened
        window.scroll(0, _windowPosition);
      };

      const preventScroll = async function() {
        _windowPosition = window.scrollY;

        $body.classList.add('locked');
        $body.style.top = `-${_windowPosition}px`;
      };

      document.addEventListener('prevent-scroll', preventScroll);
      document.addEventListener('restore-scroll', restoreScroll);
    }();

    const setupVideoPlayBack = function() {
      const $videos = document.querySelectorAll('[mm-video]');
      if (!$videos.length) { return; }

      $videos.forEach(($video) => {
        const videoUrl = $video.dataset.url;
        if (!videoUrl) { return; }

        const $videoEl = document.createElement('video');

        $videoEl.src = videoUrl;
        $videoEl.load();
        $videoEl.autoplay = true;
        $videoEl.playsInline = true;
        $videoEl.controls = false;
        $videoEl.loop = true;
        $videoEl.muted = true;
        $videoEl.preload = 'auto';

        $video.appendChild($videoEl);
        $video.setAttribute('loaded', true);

        const hideVideo = function() {
          $video.style.setProperty('display', 'none');
        };

        $videoEl.addEventListener('abort', hideVideo);
        $videoEl.addEventListener('error', hideVideo);
      });
    }();

    const setupResizeListener = function() {
      const bodyResized = new Event('body:resized')
      let windowWidth = window.innerWidth;

      const bodyObserver = new ResizeObserver(() => {
        const newWidth = window.innerWidth;

        if (windowWidth != newWidth) {
          document.dispatchEvent(bodyResized);

          windowWidth = newWidth;
        }
      });

      bodyObserver.observe($body, {box: 'border-box'});
    }();

    const setupLazyLoading = function() {
      const checkForLazyLoadedImages = function() {
        const $lazyLoadImages = document.querySelectorAll('[mm-load]');
        if (!$lazyLoadImages.length) { return; }
  
        $lazyLoadImages.forEach(async ($lazyLoad) => {
          if ($lazyLoad.hasAttribute('loaded')) { return; }
  
          if ($lazyLoad.complete) {
            await new Promise(r => setTimeout(r, 100));
  
            $lazyLoad.setAttribute('loaded', true);
          } else {
            $lazyLoad.onload = function() {
              $lazyLoad.setAttribute('loaded', true);
            }
          }
        });
      };
  
      checkForLazyLoadedImages();
      document.addEventListener('variant:info-updated', checkForLazyLoadedImages);
    };

    // scroll back to last scroll position
    history.scrollRestoration = 'manual';

    // shopify admin refresh
    document.addEventListener('shopify:section:load', () => {
      setupLazyLoading();
    });

    setupLazyLoading();
  });
  
  window.addEventListener('load', () => {
    // sometimes anchor links are clicked and intersection observer doesn't kick in
    // this function will make sure that we're looking into this
    const $scrollPixel = document.querySelector('scroll-pixel');
    const updateHeader = function() {
      if (!$scrollPixel) { return; }

      if (window.scrollY > $scrollPixel.offsetTop) {
        document.body.setAttribute('scrolled', true);
      }
    };
    
    const scrollToAnchorLinks = function() {
      const hash = window.location.hash.replace('#', '');
      
      const anchorUpdate = function() {
        const $anchoredSection = document.querySelector(`[data-id=${hash}]`);

        if ($anchoredSection) {
          setTimeout(function () {
            $anchoredSection.scrollIntoView(true);
            updateHeader();
          }, 100);
        }
      };
      
      if (!!hash) {
        anchorUpdate();
      }
    }();

    const handleSelfAnchorLinks = function() {
      const hash = window.location.hash.replace('#', '');
      if (!!!hash) { return; }
      
      const curentURL = window.location.href;
      const $anchorLinks = document.querySelectorAll('a[href*="#"]');
      $anchorLinks.forEach(($anchorLink) => {
        const baseURL = $anchorLink.getAttribute('href').split('#')[0];
        if (curentURL.includes(baseURL)) {
          $anchorLink.addEventListener('click', function(e) {
            e.preventDefault();
            window.location.href = $anchorLink.href;
            window.location.reload();
          });
        } 
      });

    }();
  });

  /*
  const reloadPageOnBackButton = function() {
    window.addEventListener('pageshow', (e) => {
      const historyPage =
        e.persisted
        || (typeof window.performance != 'undefined' && window.performance.getEntriesByType('navigation')[0].type === 'back_forward' );

      console.log(window.performance.getEntriesByType('navigation')[0].type)
      if (historyPage) {
        window.location.reload();
      }
    });
  }();
  */
}());
